<template>
  <div class="index_box">
    <div class="banner">
      <swiper :options="swiperOption" style="height:56.25vw">
        <swiper-slide v-for="item in banners" v-bind:key="item">
          <div :style="'background-image:url(' + item + ')'" class="banner_img">
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
       </swiper>
      <div class="moreVideo">
        <router-link to="/video/5285890809975080336">More program videos &gt;&gt;</router-link>
      </div>
    </div>
    <div class="intro">
      <div class="content">
        <div class="top">
          <div class="left">
            <img src="../../assets/images/introleft.png" alt="">
          </div>
          <div class="right">
            <img src="../../assets/images/title/gygs.png" alt="">
            <p style="margin-bottom:20px;">GASA (Global Academy of Science and Arts) is an innovative education organization established in 2016 by Wen Chu, Founder of GWC and GMIC. With the vision of "New Scientific Renaissance" granted by Stephen Hawking, GASA has been creating an exclusive communication platform across various industries to connect leading entrepreneurs in and outside China with top-tier scientists in the world. We value the spirit of science and are committed to revitalizing our community by exploring new frontiers in science, innovation and society.</p>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
    </div>
    <div id="xd">
      <div id="manager" class="dw"></div>
      <div class="title">
        <img src="../../assets/images/title/xdh.png" alt="">
      </div>
      <div class="content">
        <div class="items">
          <div v-for="(item, index) in xdList"  :key="item.id" :class="(item.id == 6 || item.id === xdNum) ? 'item active' : 'item'" @mousemove="changeXdNum(item.id)" @mouseout="recoverXdNum">
            <div v-if="item.id == 6">
              <div class="black_bg">
                <div class="xd_intro">
                  <p class="xd_name" v-html="xdList[index].name"></p>
                  <p class="xd_title">{{xdList[index].title}}</p>
                  <p class="xd_company" v-if="xdList[index].company">{{xdList[index].company}}</p>
                </div>
              </div>
            </div>
            <div v-else>
              <img :src="item.img_url" alt=""/>
              <div class="bg">
                <div class="xd_intro">
                  <p class="xd_name" v-html="xdList[xdNum].name"></p>
                  <p class="xd_title">{{xdList[xdNum].title}}</p>
                  <p class="xd_company" v-if="xdList[xdNum].company">{{xdList[xdNum].company}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="gw">
      <div id="committee" class="dw"></div>
      <div class="content">
        <div class="left">
          <img src="../../assets/images/title/gwwyh.png" alt="">
          <div class="items">
            <div class="item" v-for="item in gwList" :key="item.id" @mousemove="changeGwNum(item.id)" @mouseout="recoverGwNum">
              <img :src="item.img_url" alt="">
            </div>
          </div>
        </div>
        <div class="right">
          <div class="gw_intro">
            <img :src="gwList[gwNum].img_url" alt="">
            <p class="gw_name">{{gwList[gwNum].name}}</p><br/>
            <p class="gw_title" v-html="gwList[gwNum].title"></p>
            <p class="gw_company" v-if="gwList[gwNum].company" v-html="gwList[gwNum].company"></p>
          </div>
        </div>
      </div>
      <div class="bg">
        <div class="leftbg"></div>
        <div class="rightbg"></div>
      </div>
    </div>
    <features></features>
    
    <div id="course">
      <div id="curriculum" class="dw"></div>
      <div class="title">
        <img src="../../assets/images/title/gskc.png" alt="">
        <!-- <p>高山课程，title资源待更新（remove）</p> -->
      </div>
      <div class="content">
        <div class="top">
          <div class="left">
            <div class="item" style="margin-bottom:6px;">
              <img src="../../assets/images/course/kxqm.jpg" alt="">
              <p>Silicon Valley · USA</p>  
            </div>
            <div class="right_bottom item" style="margin-top:0;">
              <img src="../../assets/images/course/cjzd.jpeg" alt="">
              <p>Tokyo · Japan</p>
            </div>
            <div class="item">
              <img src="../../assets/images/course/hdywm.jpeg" alt="">
              <p>Qingdao · China</p>
            </div>
          </div>
          <div class="right">
            <div class="right_top">
              <div class="right_left item">
                <img src="../../assets/images/course/jps.jpg" alt="">
                <p>Jinping Mountain · China</p>
              </div>
              <div class="right_right">
                <div class="item">
                  <img src="../../assets/images/course/jdkxqy.png" alt="">
                  <p>London · UK </p>
                </div>
              </div>
            </div>
            <div class="item">
              <img src="../../assets/images/course/kxqy.jpeg" alt="">
              <p>Boston-NYC · USA</p>  
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="item">
            <img src="../../assets/images/course/qd.jpg" alt="">
            <p>Qingdao · China</p>
          </div>
          <div class="item">
            <img src="../../assets/images/course/xsbn.jpg" alt="">
            <p>Xishuangbanna · China</p>
          </div>
        </div>
      </div>
    </div>

    <message></message>
    <!-- zsxx -->

    <div id="gsgy">
      <div class="title">
        <img src="../../assets/images/title/gy.png" alt="">
        <!-- <p>No matter how small a good deed is, it can always inspire more energy.</p> -->
      </div>
      <!-- <div class="gy_intro">
        <div class="left">
          <div class="blue">
            <div class="kxfx"></div>
            <img class="kxfx" src="../../assets/images/kxfx1.png" alt="">
            <img class="kxfxen" src="../../assets/images/kxfxen.png" alt="">
          </div>
          <div class="gray"><div></div></div>
        </div>
        <div class="right">
          <p class="gy_title">
            GASA Science Philanthropy
          </p>
          <p class="gy_content">
            Promoting the scientific spirit and ideas.
          </p>
        </div>
      </div> -->
      <div class="content" style="padding-top: 0;">
        <div class="items">
          <div class="item">
            <img src="../../assets/images/kxgy2.png" alt="">
            <div class="kx_title">Zhang Shoucheng  Scholarship</div>
            <div class="kx_intro">
              <!-- <b>Introduction:</b><br/> -->
              It is set up in memory of the late Professor Zhang Shoucheng, the Founding Board Member of GASA. Every year, it is open for application to all entrepreneurs under the age of 35. All candidates should demonstrate strong interest and potential in science. We believe in the constant support from GASA community and hope that Zhang Shoucheng Scholarship will inspire the awardees in their pursuit.
              <br><br><b>Eligibility:</b><br>
              <b>You can apply for Zhang Shoucheng  Scholarship if you are:</b><br>
              1. Aged 35 and under,  Founder, CEO or Partner of a business or fund;<br>
              2. Strong interest in science;<br>
              3. Your business retains top rank in industry or with great potentials;<br>
              4. At least one recommendation letter from current GASA alumni;<br>
              5. Ready to be screened by GASA Interview Committee;
            </div>
          </div>
          <div class="item">
            <img src="../../assets/images/gsjd.png" alt="">
            <div class="kx_title">GASA Classics</div>
            <div class="kx_intro">
              GASA Classics is a Popular Science public welfare project. 100 well-known scientists are invited to guide the reading of 100 best science books of all time. Each reading session is aired every week via various leading streaming platforms to engage the public and cultivate science literacy in China.
              <p></p>
              <p>In the future, GASA Classics will develop three core products: GASA Classics Book Series, Live Streaming of GASA Classics Reading Sessions, Archived Video Programs. We focus on educating general audience who has curious minds and bringing positive impact on our society.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "index.page.less";
  .speakerSwiperItem {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    img{
      height:250px;
      width:auto;
    }
}
</style>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Features from './features/features.vue'
import Message from './message/message.vue'

export default {
  components: {
    swiper,
    swiperSlide,
    Features,
    Message
  },
  data () {
    return {
      articlelist: [],
      timerxd: null,
      timergw: null,
      timerinter: null,
      xdNum: 0,
      gwNum: 0,
      interNum: 0,
      banners: [
        '/static/banner3.jpg'
      ],
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 30,
        mousewheel: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        }
      },
      swiperOption2: {
        slidesPerView: 2,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      xdList: [
        {
          id: 0,
          name: 'Lu Bai',
          title: '',
          company: 'Professor of Tsinghua University',
          img_url: '/static/xd/lb.png'
        },
        {
          id: 1,
          name: 'Wen Chu',
          title: 'Founder of GASA',
          company: '',
          img_url: '/static/xd/wc.png'
        },
        {
          id: 2,
          name: 'Wu Guosheng',
          title: 'Professor of Tsinghua University',
          company: '',
          img_url: '/static/xd/wgs.png'
        },
        {
          id: 3,
          name: 'Xue Lan',
          title: 'Dean of Schwarzman College at Tsinghua University',
          company: '',
          img_url: '/static/xd/xl.png'
        },
        {
          id: 4,
          name: 'Xia Zhihong（Jeff)',
          title: 'Mathematician',
          company: 'Professor  of Northwestern University',
          img_url: '/static/xd/xzh.png'
        },
        {
          id: 5,
          name: 'Zhou Zhonghe',
          title: 'Paleontologists',
          company: 'Academician of Chinese Academy of Sciences, International Member of National Academy of Sciences',
          img_url: '/static/xd/zzh.png'
        },
        {
          id: 6,
          name: 'A special tribute to<br>Zhang Shoucheng',
          title: 'Professor of Stanford University',
          company: '',
          img_url: ''
        },
        {
          id: 7,
          name: '',
          title: '',
          company: '',
          img_url: '/static/xd/zsc.png'
        }
      ],
      gwList: [
        {
          id: 0,
          name: 'Guo Yike',
          title: 'Academician of the European Academy of Sciences',
          company: 'Fellow of the Royal Academy of Engineering Professor, Imperial College London <br/>Vice President, Hong Kong Baptist University',
          img_url: '/static/gw/gyk.jpg'
        },
        {
          id: 1,
          name: 'Li Di',
          title: 'Chief Scientist of FAST, National Astronomical Observatories of Chinese Academy of Sciences',
          company: '',
          img_url: '/static/gw/ld.jpg'
        },
        {
          id: 2,
          name: 'Mao Shude',
          title: 'Professor and Director of the Department of Astronomy, Tsinghua University',
          company: '',
          img_url: '/static/gw/msd.jpg'
        },
        {
          id: 3,
          name: 'Pan Jianwei',
          title: 'Academician of Chinese Academy of Sciences<br/>Executive and Vice President, University of Science and Technology of China',
          company: 'Director, CAS Center for Excellence in Quantum Information and Quantum Physics',
          img_url: '/static/gw/pjw.jpg'
        },
        {
          id: 4,
          name: 'Qi Yan',
          title: 'Senior Consultant of Xiaomi Corporation',
          company: '',
          img_url: '/static/gw/qy.jpg'
        },
        {
          id: 5,
          name: 'Wang Yifang',
          title: 'Academician of Chinese Academy of Sciences<br/>International Member of the Russian Academy of Sciences<br/>Academician of the Academy of Sciences for Developing Countries',
          company: 'Director, Institute of High Energy Physics of Chinese Academy of Sciences',
          img_url: '/static/gw/wyf.jpg'
        },
        {
          id: 6,
          name: 'Wu Jun',
          title: 'Founder and Managing Partner at AMINO Capital',
          company: '',
          img_url: '/static/gw/wj.jpg'
        },
        {
          id: 7,
          name: 'Yu Minhong(Michael)',
          title: 'Founder and Chairman, New Oriental Education and Technology Group',
          company: '',
          img_url: '/static/gw/ymh.jpg'
        },
        {
          id: 8,
          name: 'Zhou Haihong',
          title: 'Music Psychologist',
          company: 'Former Deputy Director, the Central Conservatory of Music',
          img_url: '/static/gw/zhh.jpg'
        },
        {
          id: 9,
          name: 'Zhang Hongjiang',
          title: 'International Member of the National Academy of Engineering<br/>Chairman of Beijing Academy of Artificial Intelligence',
          company: 'Venture Partner at Source Code Capital',
          img_url: '/static/gw/zhj.png'
        },
        {
          id: 10,
          name: 'Zhang Shuangnan',
          title: 'Research Fellow, Institute of High Energy Physics, Chinese Academy of Sciences',
          company: 'Professor of University of Chinese Academy of Sciences',
          img_url: '/static/gw/zsn.jpg'
        },
        {
          id: 11,
          name: 'Zhang Wenhong',
          title: 'Director, Department of Infectious Diseases, Huashan Hospital Affiliated to Fudan University',
          company: 'Director of the Internal Medicine Department, Shanghai Medical College',
          img_url: '/static/gw/zwh.jpg'
        }
      ],
      intertnationalList: [
        {
          id: 0,
          name: 'BeiJing',
          img_url: '/static/international/bj.jpg',
          title: 'Beijing station',
          intro: ''
        },
        {
          id: 1,
          name: 'Israel',
          img_url: '/static/international/ysl.jpg',
          title: 'Israel Station · Origin of religion and civilization',
          intro: ''
        },
        {
          id: 2,
          name: 'Silicon Valley',
          img_url: '/static/international/gg.jpg',
          title: 'Silicon Valley Station·',
          intro: ''
        },
        {
          id: 3,
          name: 'Boston, USA',
          img_url: '/static/international/bsd.jpg',
          title: 'Boston Station ·',
          intro: ''
        },
        {
          id: 4,
          name: 'Japan',
          img_url: '/static/international/rb.jpg',
          title: 'Japan Station · Long-term way',
          intro: ''
        },
        {
          id: 5,
          name: 'India',
          img_url: '/static/international/yd.jpg',
          title: 'India Station ·',
          intro: ''
        },
        {
          id: 6,
          name: 'Greece',
          img_url: '/static/international/xl.jpg',
          title: 'Greece Station ·',
          intro: ''
        },
        {
          id: 7,
          name: 'U.K',
          img_url: '/static/international/yg.jpg',
          title: 'British Station · The greatest truths are the simplest.',
          intro: '《教育与科学》<br>Lucy Hawking<br>英国记者，理论物理学家斯蒂芬·霍金之女<p></p>《这是我们最后的世纪吗》<br>Martin Rees<br>曾任英国皇家学会会长和剑桥大学三一学院院长<p></p>《大脑定位系统与神经科学的未来趋势》<br>John O’Keefe<br>2014年获诺贝尔生物学奖，2013年获霍维茨奖<br>美国籍神经科学家，以发明海马体中位置细胞闻名<p></p>《未来世界的新材料》<br>Konstantin Novoselov<br>诺奖得主，石墨烯发明人<p></p>《万维网创立30年后需要的转变》<br>Tim Berners-Lee<br>万维网发明者，图灵奖得主<p></p>《Alpha go的未来》<br>Demis Hassabis<br>Deepmind创始人&CEO'
        },
        {
          id: 8,
          name: 'Italy',
          img_url: '/static/international/ydl.jpg',
          title: 'Italy Station ·',
          intro: ''
        }
      ]
    }
  },
  created () {
    let self = this
    // self.getArticle()
    self.timerxd = setInterval(function () {
      if (self.xdNum === 6) {
        self.xdNum = 0
      } else {
        self.xdNum++
      }
    }, 3000)
    self.timergw = setInterval(function () {
      if (self.gwNum === 11) {
        self.gwNum = 0
      } else {
        self.gwNum++
      }
    }, 5000)
    // self.timerinter = setInterval(function () {
    //   if (self.interNum === 8) {
    //     self.interNum = 0
    //   } else {
    //     self.interNum++
    //   }
    // }, 3000)
  },
  methods: {
    getArticle: function () {
      let that = this
      that.$http.get('https://pyapi.gasauniversity.com/v1/news/get_top/4')
        .then(function (res) {
          that.articlelist = res.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showvideo: function () {
      this.videosrc = 'http://1252569314.vod2.myqcloud.com/97afcfedvodtransgzp1252569314/56547c1c5285890781445892288/v.f30.mp4'
      let thisvideo = document.getElementById('video1')
      thisvideo.play()
      this.isshowvideo = true
    },
    hidevideo: function () {
      let thisvideo = document.getElementById('video1')
      thisvideo.pause()
      this.isshowvideo = false
    },
    changeXdNum: function (n) {
      if (n !== 7 || n !== 6) {
        this.xdNum = n
        let self = this
        clearInterval(self.timerxd)
      }
    },
    changeGwNum: function (n) {
      this.gwNum = n
      let self = this
      clearInterval(self.timergw)
    },
    changeInterNum: function (n) {
      this.interNum = n
      let self = this
      clearInterval(self.timerinter)
    },
    recoverXdNum: function () {
      let self = this
      if (self.timerxd !== null) {
        clearInterval(self.timerxd)
      }
      self.timerxd = setInterval(function () {
        if (self.xdNum === 7) {
          self.xdNum = 0
        } else {
          self.xdNum++
        }
      }, 3000)
    },
    recoverGwNum: function () {
      let self = this
      if (self.timergw !== null) {
        clearInterval(self.timergw)
      }
      self.timergw = setInterval(function () {
        if (self.gwNum === 11) {
          self.gwNum = 0
        } else {
          self.gwNum++
        }
      }, 5000)
    },
    recoverInterNum: function () {
      let self = this
      if (self.timerinter !== null) {
        clearInterval(self.timerinter)
      }
      self.timerinter = setInterval(function () {
        if (self.interNum === 8) {
          self.interNum = 0
        } else {
          self.interNum++
        }
      }, 3000)
    }
  },
  beforeDestroy () {
    let self = this
    clearInterval(self.timerxd)
    clearInterval(self.timergw)
    // clearInterval(self.timerinter)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/index.vue